module fdm.rawFiles {

    class SegmentsInRawFileController {

        public link: dg.restfulApi.Link;
        public query: any;
        public queryManipulator: dg.actions.ServerQueryManipulator;

        public options = dg.lists.ListOptionsService.getGridOptions({
            type: 'grid',
            useExternalSorting: true,
            useGridScroll: false,
            uiGrid: {
                enableSorting: true,
                columnDefs: [
                    { field: 'aggregate', width: 125, displayName: 'Number' },
                    { field: 'legDate', minWidth: 110  },
                    { field: 'subFramesCount', minWidth: 130 },
                    { field: 'departure', minWidth: 85 },
                    { field: 'arrival', minWidth: 80 },
                    { field: 'registration', minWidth: 95 },
                    //{ field: 'flightNo', width: 75 },
                    //{ field: 'airborne', width: 75 },
                    //{ field: 'taxiOut', width: 75 },
                    { field: 'skipReason', minWidth: 140 },
                    { field: 'duplicateLeg', width: 110 },
                    { field: 'milestones.Skipped', width: 85 }
                ]

            },

        });

        public constructor(
            public $scope: any,
            private $q: ng.IQService,
            private $element: ng.IAugmentedJQuery,
            protected actionService: dg.actions.ActionService) {
        }

        $onChanges(changes) {
            if (changes.link.currentValue) {
                this.getData();
            }
        }

        async getData() {
            this.query = await this.actionService.getActionFromLink(this.link);
            this.queryManipulator = new dg.actions.ServerQueryManipulator(this.$scope, this.$q, this.query, this.actionService);
            this.queryManipulator.executeQuery();
        }
    };

    angular.module('fdm.rawFiles').component('segmentsInRawFile', {
        bindings: {
            link: '<',
        },
        controller: SegmentsInRawFileController,
        templateUrl: '/app/src/raw-files/segments-in-raw-file.html'
    });
}
